import React, { useEffect, useState } from 'react';
import UsersTable from '../users-table/users-table';
import FullSizeContainer from '../containers/full-size/full-size-container';
import Loading from '../loading/loading';
import Logos from '../logos/logos';
import Seat from '../seat-use/seats';
import HintIcon from '../hint-icon/hint-icon';
import '../common/common.css';

function AccountAdmin() {
  const [loading, setLoading] = useState(false);
  const [accountData, setAccountData] = React.useState({});
  const [newUsers, setNewUsers] = React.useState('');
  const [refreshKey, setRefreshKey] = React.useState(0);
  const [image, setImage] = React.useState(null);

  useEffect(() => {
    setLoading(true);
    (async () => {
      const res = await fetch(
        process.env.REACT_APP_FACES_API_BASE +
          '/accounts?account_id=' +
          localStorage.getItem('facesAccountID'),
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('facesIDToken')}`,
          },
        }
      );

      const j = await res.json();
      setAccountData(j);
      setLoading(false);
    })();
  }, []);

  const addUsers = async () => {
    setLoading(true);
    try {
      const cleaned = newUsers
        .split(',')
        .map((s) => s.replace(/\s+/g, '')) // remove inner spaces per address
        .filter(Boolean) // drop empties
        .join(',');
      await fetch(process.env.REACT_APP_FACES_API_BASE + '/account-users', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('facesIDToken'),
        },
        body: JSON.stringify({
          email: cleaned,
        }),
      });
    } catch (e) {
      console.log(e);
      alert('Failed to create new users: ' + e);
    } finally {
      setLoading(false);
      setNewUsers('');
      setRefreshKey(refreshKey + 1);
    }
  };

  const onImageChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setImage(file);
  };

  const uploadImage = async () => {
    if (!image) return;
    try {
      setLoading(true);
      const res = await fetch(
        process.env.REACT_APP_FACES_API_BASE + '/account-branding',
        {
          method: 'POST',
          headers: {
            'Content-Type': image.type || 'application/octet-stream',
            Authorization: 'Bearer ' + localStorage.getItem('facesIDToken'),
          },
          body: image,
        }
      );

      if (res.ok) {
        setRefreshKey(refreshKey + 1);
      }
    } catch (e) {
      alert('Failed to upload image: ' + e);
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  if (loading)
    return (
      <FullSizeContainer>
        <Loading />
      </FullSizeContainer>
    );
  return (
    <FullSizeContainer title="ACCOUNT ADMINISTRATION">
      <div
        style={{
          marginTop: '5px',
          marginBottom: '0px',
          display: 'flex',
          flexDirection: 'row',
          flexGrow: 0,
          width: '100%',
        }}
      >
        <div
          style={{
            alignSelf: 'flex-start',
            flexGrow: 0,
            maxWidth: 128,
            marginRight: '20px',
          }}
        >
          <Logos widthOverride={128} />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            marginBottom: '2rem',
          }}
        >
          <h2 style={{ marginTop: 0, alignSelf: 'flex-start' }}>
            {accountData.account_name}
          </h2>
          <div
            style={{
              marginBottom: '20px',
              marginTop: 0,
              alignSelf: 'flex-start',
            }}
          >
            <Seat />
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '1rem',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
            }}
          >
            <label style={{ flex: 1 }}>
              <h3 className="flex-row-center">
                ACCOUNT LOGO:
                <HintIcon hint="Images should be in PNG or JPG format, ideally 300x300 pixels for best results." />
              </h3>
              <input
                onChange={onImageChange}
                type="file"
                name="customLogo"
                accept="image/*"
                style={{ marginTop: 4 }}
                id="branding-upload"
              />
            </label>
            <button
              className="button"
              style={{ marginBottom: 2, padding: '0.75rem 2rem' }}
              onClick={uploadImage}
            >
              <b>CHANGE</b>
            </button>
          </div>
        </div>

        <div
          style={{
            width: '40%',
            height: '100%',
            marginLeft: '80px',
            justifyContent: 'center',
            gap: '1rem',
            flexDirection: 'column',
            alignItems: 'stretch', // Stretch children to full width
          }}
        ></div>
      </div>
      <div
        style={{
          width: '100%',
          height: '2px',
          background: '#23284d',
          margin: '0',
          borderRadius: 2,
        }}
      />

      <div
        style={{
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
          marginTop: '20px',
          marginBottom: '20px',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <h3 className="flex-row-center">
            ADD USERS BY EMAIL:
            <HintIcon hint="Separate multiple email addresses using spaces, commas or place each address on a new line." />
          </h3>
          <textarea
            onChange={(e) => setNewUsers(e.target.value)}
            name="addUsers"
            placeholder="user1@email.com, user2@email.com"
            style={{
              marginTop: 4,
              height: '100%',
              resize: 'vertical',
              minHeight: 120,
            }}
          />
        </div>
        <button
          className="button"
          onClick={addUsers}
          style={{ marginBottom: 2, alignSelf: 'flex-start' }}
        >
          <b>SEND EMAIL INVITATIONS</b>
        </button>
      </div>

      <div
        style={{
          width: '100%',
          height: '2px',
          background: '#23284d',
          margin: '0',
          borderRadius: 2,
        }}
      />

      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            width: '100%',
            maxWidth: '100%',
            alignItems: 'flex-start',
          }}
        >
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              gap: '1rem',
              flexDirection: 'column', // Change to column to stack textarea and button
              alignItems: 'stretch', // Stretch children to full width
            }}
          >
            <label style={{ flex: 1 }}>
              <h3 className="flex-row-center">
                AUTHORIZED USERS:
                <HintIcon hint="Manage users in your account. You can use the icons in the table to reset passwords, edit or remove users." />
              </h3>
              <UsersTable accountData={accountData} refreshKey={refreshKey} />
            </label>
          </div>
        </div>
      </div>
    </FullSizeContainer>
  );
}

export default AccountAdmin;
